<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17ZOshK/tc-custom/9781467442213.jpg?1728851905426" alt="This image is the cover for the book Faith Seeking Understanding"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Faith Seeking Understanding
      </h1>
      <p class="bookDescription body article font2">
        <p>A superb, standard Christian theology text for nearly a quarter century, Daniel Migliore's <i>Faith Seeking Understanding</i> explores all of the major Christian doctrines in freshly contemporary ways. This third edition offers new FOR FURTHER READING suggestions at the end of each chapter, a substantial expansion of the glossary, and new material incorporated throughout, including a section on Christians and Muslims.<br/><br/>Further, the three imaginary theological dialogues culminating the book -- pointedly playful exchanges that have delighted countless readers -- are here joined by a fourth dialogue, between Karl Barth and Friedrich Nietzsche, on atheism. All in all, a new generation of students, pastors, and Christian educators, eager to better understand the rich heritage, central themes, and contemporary challenges of Christian theology, will find both guidance and stimulation in Migliore's updated work. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daniel L. Migliore
      </h2>
      
      <p class="authorDescription body article">&#160;<B>Daniel L. Migliore</B>&#160;is Charles Hodge Professor Emeritus of Systematic Theology at Princeton Theological Seminary.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?68503154